import React from 'react';

import type {Feat} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {featCategoryText, featDescription} from './feat-seo-text';

export const FeatSeo: React.FC<{feat: Feat}> = ({feat}) => (
	<EntitySeo
		entity={feat}
		section="feats"
		kind="черта"
		description={featDescription(feat)}
		path={buildUrl('feat', {id: feat.id})}
		og={{kind: 'feat'}}
		keywords={[featCategoryText(feat)]}
	/>
);
